/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from "react";
// import { Link } from "gatsby";
import { RouteComponentProps } from "@reach/router";

// #region Componets
import BasePureComponet from "../../components/Base/BasePureComponet";
import Layout from "../../components/layout";
import SideBarRight from "./SideBarRight/SideBarRight";
import SideBarLeft from "./SideBarLeft/SideBarLeft";
import Service from "./Service/Service";
import Discover from "./Discover/Discover";
import Post from "./Post/Post";
import Share from "./Share/Share";
// #endregion Componets

// Style
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import "./Home.scss";

interface HomeProp extends RouteComponentProps {
  title: string;
}

class Home extends BasePureComponet<HomeProp> {
  render() {
    return (
      <Layout title={this.props.title}>
        <MDBContainer fluid className="h-100 home-page">
          <MDBRow className="w-100 h-100 mx-0">
            <MDBCol className="h-100 order-md-1 order-1" lg={"3"} md={"4"}>
              <SideBarRight />
            </MDBCol>
            <MDBCol
              className="h-100 home order-md-2 order-3 pb-5"
              lg={"6"}
              md={"8"}
            >
              <Service />
              <Discover />
              <Share />
              <Post />
            </MDBCol>
            <MDBCol
              className="h-100 order-md-3 order-2 d-lg-block d-md-none"
              lg={"3"}
              md={"1"}
            >
              <SideBarLeft />
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </Layout>
    );
  }
}
export default Home;
